const isProduction = process.env.NODE_ENV === 'production';

export default {
    debug: isProduction ? Function.prototype : console.debug,
    error: isProduction ? Function.prototype : console.error,
    log: isProduction ? Function.prototype : console.log,
    warn: isProduction ? Function.prototype : console.warn
};